import { App } from 'vue'
import { createI18n } from 'vue-i18n'
import en from './en'
import de from './de'

const i18n = createI18n<[typeof en], 'en' | 'de'>({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'de',
  messages: {
    en: { ...en },
    de: { ...de }
  }
})

/**
 * Merges module-scoped translations into the active i18n instance.
 *
 * Called once from `main.ts` after i18n is fully initialized but before the
 * app mounts. Keeping this out of the plugin's own module graph avoids the
 * circular dependency that would otherwise form between i18n and the module
 * registry (which re-exports routes that import i18n).
 */
export function registerModuleTranslations(
  translations: Record<string, { en?: Record<string, any>; de?: Record<string, any> }>
) {
  for (const moduleKey in translations) {
    const entry = translations[moduleKey]
    if (entry.en) i18n.global.mergeLocaleMessage('en', entry.en)
    if (entry.de) i18n.global.mergeLocaleMessage('de', entry.de)
  }
}

const i18nPlugin = {
  install(app: App) {
    app.use(i18n)
  }
}

export { i18n }
export default i18nPlugin
